 
import * as React from 'react';
import { Row } from "antd";

export const ChatMessageGroup = (props) => {

  const { message, renderItem, ...viewProps } = props;

  const renderMessage = (item, key) => {
    // @ts-ignore
    return React.cloneElement(renderItem(item), { key });
  };
  return (
    <Row {...viewProps}>
      {renderMessage(message)}
    </Row>
  );
};